<template>
  <div :class="currentRouteIsShop ? 'shop-filters' : ''">
    <div class="color-filters">
      <h4>Colors</h4>
      <ul class="color-filters-list">
        <li v-for="(filter, index) in colorFilters" :key="index" :aria-label="`Filter by ${filter.name}`">
          <input aria-hidden="true" type="checkbox" :id="`toggle-filters[${index}]`" :checked="filter.checked"
                :value="filter.code" @change="toggleColorFilter(filter.code)">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "color-filters",

    computed: {
      ...mapGetters([
        'colorFilters'
      ]),
      currentRouteIsShop() {
        return window.location.pathname === '/shop/powder-coating-colors';
      }
    },

    methods: {
      ...mapActions([
        'toggleColorFilter'
      ])
    }
  }
</script>
